import { component } from '@reduct/component';
import propTypes from '@reduct/nitpick';

import {TouchSwipeEmitter} from './../../Utils/';
import Slider, { eventNames } from './slider';

import app from '../../assembler';

@component({
	type: propTypes.string,
	generateThumbs: propTypes.number,
})
class ContentSlider {
	constructor() {
		const el = this.getElement();
		const indexWrapper = this.find('[data-indexNav]');
		const slidesWrapper = this.find('[data-wrapper]');
		const swipeEmitter = new TouchSwipeEmitter(slidesWrapper);

		this.slider = new Slider(el, {
			slidesWrapper,
			indexWrapper,
			indexAnchors: indexWrapper ? indexWrapper.children : null,
			nextAnchor: this.find('[data-next]'),
			prevAnchor: this.find('[data-prev]')
		});

		swipeEmitter.on('swipeLeft', () => {
			this.slider.trigger(eventNames.slideNext);
		});

		swipeEmitter.on('swipeRight', () => {
			this.slider.trigger(eventNames.slidePrev);
		});

		if(this.props.generateThumbs === 1) {
			this.generateThumbnails();
		}
	}

	generateThumbnails() {
		const el = this.getElement();
		const slideWrapper = el.querySelector('[data-wrapper]');
		const slides = Array.prototype.slice.apply(slideWrapper.children);
		const thumbsWrapper = document.createElement('div');
		const thumbsInnerWrapper = document.createElement('div');

		// ToDo: Abstract.
		thumbsWrapper.classList.add('contentSlider__thumbsWrapper');
		thumbsInnerWrapper.classList.add('contentSlider__thumbsWrapper__inner');

		// Append the childs & thumbs.
		thumbsWrapper.appendChild(thumbsInnerWrapper);

		slides.forEach((slide, index) => {
			const thumb = document.createElement('img');

			thumb.setAttribute('src', slide.querySelector('img').getAttribute('src'));
			thumb.classList.add('u-w1/10');
			thumb.addEventListener('click', e => {
				e.preventDefault();
				this.slider.trigger(eventNames.slide, { index });
			});

			thumbsInnerWrapper.appendChild(thumb);
		});

		this.thumbsWrapper = thumbsWrapper;
		this.thumbsInnerWrapper = thumbsInnerWrapper;

		el.appendChild(this.thumbsWrapper);

		// Generate the navigation.
		this.generateThumbnailNavigation();
	}

	generateThumbnailNavigation() {
		const thumbsWrapper = this.thumbsWrapper;
		const thumbsInnerWrapper = this.thumbsInnerWrapper;
		const thumbs = Array.prototype.slice.call(thumbsInnerWrapper.children);
		const thumbsWrapperNextAnchor = document.createElement('a');
		const thumbsWrapperPrevAnchor = document.createElement('a');

		// Setup the thumbnail navigation.
		thumbsWrapperPrevAnchor.classList.add('contentSlider__thumbsWrapper__nav');
		thumbsWrapperPrevAnchor.classList.add('contentSlider__thumbsWrapper__nav--prev');
		thumbsWrapperPrevAnchor.setAttribute('data-nav', 'prev');
		thumbsWrapperPrevAnchor.addEventListener('click', this.onThumbNavigationClick.bind(this));
		thumbsWrapperPrevAnchor.innerHTML = '<';

		thumbsWrapperNextAnchor.classList.add('contentSlider__thumbsWrapper__nav');
		thumbsWrapperNextAnchor.classList.add('contentSlider__thumbsWrapper__nav--next');
		thumbsWrapperNextAnchor.setAttribute('data-nav', 'next');
		thumbsWrapperNextAnchor.addEventListener('click', this.onThumbNavigationClick.bind(this));
		thumbsWrapperNextAnchor.innerHTML = '>';

		thumbsWrapper.appendChild(thumbsWrapperPrevAnchor);
		thumbsWrapper.appendChild(thumbsWrapperNextAnchor);

		const offset = 5;
		const width = thumbs.reduce((prev, curr, index) => {
			if (index > 1) {
				return prev + curr.clientWidth + offset;
			} else {
				return (curr.clientWidth + offset) * 2;
			}
		}, 100);

		this.setState({ maxThumbsOffset: width });
		thumbsInnerWrapper.style.width = `${width}px`;
	}

	onThumbNavigationClick(e) {
		e.preventDefault();

		const thumbsInnerWrapper = this.thumbsInnerWrapper;
		const type = e.target.getAttribute('data-nav');
		const maxThumbsOffset = this.state.maxThumbsOffset - (this.thumbsWrapper.clientWidth - 100); // ToDo: Get the calculated paddings instead of setting a constant value of '100'.
		const currentOffset = parseInt(thumbsInnerWrapper.style.marginLeft);
		const jumpValue = 250;
		let offset = 0;

		if (type === 'next') {
			if (currentOffset) {
				offset = Math.abs(currentOffset) + jumpValue;
			} else {
				offset = jumpValue;
			}
		} else if (currentOffset) {
			offset = Math.abs(currentOffset) - jumpValue;
		}

		if (offset > maxThumbsOffset) {
			offset = maxThumbsOffset;
		}

		if (offset < 0) {
			offset = 0;
		}

		this.thumbsInnerWrapper.style.marginLeft = `-${offset}px`;
	}

	getInitialState() {
		return {
			maxThumbsOffset: 0
		};
	}

	getDefaultProps() {
		return {
			type: 'slide',
			generateThumbs: 0
		}
	}
}

app.register(ContentSlider, 'ContentSlider');
